import { ReactNode, createContext, useContext, useMemo } from 'react';
import { useUserDetails } from 'src/common/custom-hooks';

type UserDetails = {
  email?: string;
  phone?: string;
  [key: string]: any;
} | null;

type UserContextValue = {
  isUserLoggedIn: boolean;
  [key: string]: any;
};

type UserProviderProps = {
  children: ReactNode;
};

const UserContext = createContext<UserContextValue>({ isUserLoggedIn: false });

export const UserProvider = ({ children }: UserProviderProps) => {
  const user = useUserDetails() as UserDetails;
  const value = useMemo(() => {
    const isUserLoggedIn = Boolean(user?.phone);

    if (!user) {
      return { isUserLoggedIn };
    }

    return { ...user, isUserLoggedIn };
  }, [user]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export const useUser = (): UserContextValue => useContext(UserContext);
